// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.usb-modal-v2--container {
    height: auto !important;
}

.usb-modal-v2--body {
    min-height: auto !important;
    max-height: -moz-fit-content !important;
    max-height: fit-content !important;
    overflow-y: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/auth/CIAMAuthModal.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;IAC3B,uCAAkC;IAAlC,kCAAkC;IAClC,6BAA6B;AACjC","sourcesContent":[".usb-modal-v2--container {\n    height: auto !important;\n}\n\n.usb-modal-v2--body {\n    min-height: auto !important;\n    max-height: fit-content !important;\n    overflow-y: hidden !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
